import Pages from 'layouts/Pages.jsx'
import Widgets from 'layouts/Widgets.jsx'
import Dashboard from 'layouts/Dashboard.jsx'

var indexRoutes = [
    { path: '/pages', name: 'Pages', component: Pages },
    { path: '/widgets', name: 'Widgets', component: Widgets },
    { path: '/', name: 'Home', component: Dashboard },
]

export default indexRoutes
